// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./frontend/scss/index.scss
// module id = 89
// module chunks = 0